export default function scrollToAnchor(anchorName) {
  if (anchorName) {
    let anchorElement = document.getElementById(anchorName);
    anchorElement ? anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }) : null;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/scrollToAnchor.js